import Configuration from '@/agilis/util/Configuration'

import VJsoneditor from 'v-jsoneditor'
import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'JsonEditorText',

  components: {
    VJsoneditor
  },

  props: {
    appId: String,
    documentId: String,
    version: String,
    saveDisabled: Boolean
  },

  data () {
    return {
      editorOptions: {
        mode: 'code',
        modes: ['code', 'tree'],
        enableSort: false,
        enableTransform: false,
        onValidationError: errors => (this.invalidJSON = errors.length > 0),
        onValidate: (json) => this.validateJSON(this.json)
      },
      openDialog: false,
      invalidJSON: false,
      loading: false,
      json: null,
      saving: false
    }
  },

  computed: {
    ...mapGetters({
      userIsAdmin: 'userDataStore/userIsAdmin'
    }),

    title () {
      return this.$t('label.JsonEditorTextTitle', { id: this.documentId || this.appId, version: this.version })
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    userCanEditConfig () {
      return this.userIsAdmin || Configuration.auth.userHasPrivilege('/admin/editConfig')
    },

    getConfigurationUrl (version) {
      let url = ''
      if (this.documentId) {
        switch (this.$route.name) {
          case 'applicationSettings':
            url = version ? this.$axios.agilisUrlConfigurationPartSave(this.appId, this.documentId, version)
              : this.$axios.agilisUrlConfigurationPart(this.appId, this.documentId)
            break

          default:
            url = this.$axios.agilisUrlDocument(this.appId, this.documentId)
            if (version) {
              url = url.concat(`/version/${version}`)
            }
        }
      } else {
        url = `/api/agilis/configuration/application/${this.appId}/version/${version || this.version}`
        if (this.appId === 'agilis') {
          url = `/api/agilis/configuration/version/${version || this.version}`
        }
      }
      return url
    },

    async loadConfig () {
      this.loading = true

      try {
        const url = this.getConfigurationUrl()
        const response = await Vue.axios.get(url, Vue.axios.agilisRequestConfig(url, window.envmap.VUE_APP_AGILIS_CONFIGURATOR_ENDPOINT))
        this.json = response.data
      } catch (error) {
        this.notifyError(error)
      }
      this.loading = false
    },

    resetModel () {
      this.loading = false
      this.invalidJSON = false
      this.json = null
    },

    async saveConfiguration () {
      if (this.invalidJSON) return

      this.saving = true

      try {
        const url = this.getConfigurationUrl(this.json.version) // read version from JSON: we can also update version
        await Vue.axios.post(url, this.json, Vue.axios.agilisRequestConfig(url, window.envmap.VUE_APP_AGILIS_CONFIGURATOR_ENDPOINT))
      } catch (error) {
        this.notifyError(error)
      }
      this.saving = false
      this.openDialog = false

      // Reload!
      location.reload()
    },

    validateJSON (json) {
      const errors = []

      if (json) {
        // Validate the Mongo document identifier to have a correct deployment
        const expectedId = `${json.id}-${json.version}`
        if (json._id && json._id !== expectedId) {
          errors.push({
            path: ['_id'],
            message: 'Invalid Mongo document identifier: expecting <app>-<version>'
          })
        }
        if (!json._id) {
          errors.push({
            path: [],
            message: 'Invalid Mongo document identifier: add "_id"'
          })
        }

        // Validate the appId is not modified
        if (json.id !== this.appId) {
          errors.push({
            path: 'id',
            message: 'Application id cannot be modified'
          })
        }
      }
      return errors
    }
  },

  watch: {
    openDialog (newValue) {
      if (newValue === true) {
        this.loadConfig()
      } else {
        this.resetModel()
      }
    }
  }
}
